
<mat-horizontal-stepper [linear]="isLinear" #stepper>
  <mat-step [stepControl]="stepOneForm">
    <form [formGroup]="stepOneForm">
      <!--<ng-template matStepperIcon="number"></ng-template>-->
      <!--<ng-template cdkStepLabel>-->
      <!--<div class="step-bullet"></div>
      <div class="step-title"></div>-->
      <!--</ng-template><br />-->
      <div class="card border-0">
        <div class="card-body">
          <div class="row" style="margin-top:1%">
            <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                      GOOGLE ASSISTANT PRIVACY SETTLEMENT CLAIM FORM
                    </p>
                  </div>
                </div>
              </div>
              <div class="container" style="border:1px solid #bebaba">
                <br />
                <div class="text-center" style="font-weight:bold; font-size:1.3em; text-decoration:underline">
                  INSTRUCTIONS
                </div>
                <br /><br />
                <!--<a href="https://www.googleasstistantprivacylitigation.com">www.googleasstistantprivacylitigation.com</a>-->
                This Claim Form should be filled out and submitted online or by mail if you received a notice of class action settlement and/or you believe you are a
                Settlement Class Member. <b>PLEASE REVIEW THE <a href="../../../assets/documents/In re Google Assistant Long Form Notice_Final.pdf" target="_blank">LONG-FORM NOTICE</a></b>,
                for more detailed information about the settlement.<br /><br />

                You are a Settlement Class Member if you are a member of one or both of the following Settlement Classes:<br /><br />

                You are a member of the <i><b>Purchaser Settlement Class</b></i> if you are a User who purchased a Google-Made Device in the United States or its territories
                between May 18, 2016 and March 19, 2026.<br /><br />

                You are a member of the <i><b>Privacy Settlement Class</b></i> if you are a User of Google Assistant or were a member of a User’s Household between May 18, 2016
                and March 19, 2026, and your communications were recorded or otherwise obtained by Google Assistant as a result of a False Accept or disclosed to
                any third-party review vendor.<br /><br />

                <ul>
                  <li>
                    “Users” are individuals who reside in the United States or its territories whose Google accounts were associated with at least one Google Assistant Enabled Device during the Class Period;
                  </li>
                  <li>
                    “Household” is a group of individuals sharing a common abode.
                  </li>
                  <li>
                    “Google Assistant Enabled Devices” are devices that come with Google Assistant pre-installed or on which Google Assistant can be downloaded;
                  </li>
                  <li>
                    “Google-Made Devices” are Google Assistant Enabled Devices manufactured and sold by Google either directly or through third-party retailers, including Google’s own smart home speakers (Google Home, Home Mini, and Home Max); smart displays (Google Nest Hub, and Nest Hub Max); and its Pixel smartphones;
                  </li>
                  <li>
                    “False Accept” is an instance where a Google Assistant Enabled Device records and transmits audio data to Google’s servers because a Hot Word was detected although a Hot Word was not spoken; and
                  </li>
                  <li>
                    “Hot Word” is a word or phrase (such as “OK Google” or “Hey Google”) which can be used to activate Google Assistant on certain Google Assistant Enabled Devices.
                  </li>
                </ul>
                <br />

                <p style="text-align:center; font-weight:bold">To be eligible for payment, you must submit a valid Claim no later than August 27, 2026. </p><br />

                <b>How Do I Fill Out and Submit This Claim Form?</b><br /><br />

                If you believe you are eligible and would like to submit a Claim, you have two options: (1) complete and submit this online Claim Form
                or (2) complete a paper <a href="../../../assets/documents/In re Google Assistant Claim Form_Final.pdf" target="_blank">Claim Form</a>
                and send it by First-Class Mail to:<br />

                <p style="text-align:center">
                  <br />
                  Google Assistant Privacy Settlement<br />
                  c/o A.B. Data, Ltd.<br />
                  P.O. Box 170500<br />
                  Milwaukee, WI 53217<br /><br />
                </p>

                Your Claim Form must be <b>submitted online, or postmarked, by August 27, 2026</b>. Please read and follow the instructions carefully. Make sure you include all the
                required information. If you do not provide complete and accurate information, your claim may be delayed or rejected.<br /><br />

                <b>Communications about settlement payments will be digitally sent to you via email or mobile phone text</b>. Please provide a current, valid email address and mobile
                phone number on your Claim Form. If your contact information changes after you submit your Claim Form, you must tell the Claims Administrator. Otherwise, you
                may not get your Settlement payment. The Claims Administrator will send you an email and/or mobile phone text when your Settlement payment is available. The
                email and/or mobile phone text will give you several digital payment options, such as PayPal, Venmo, Zelle, or ACH, to get your Settlement payment.
                <br /><br />
                <div class="row">
                  <div class="col-md-12 text-center">
                    <button class="btn btn-primary" matStepperNext>Enter Online Filing Site</button>
                  </div>
                </div>
                <br />

              </div>
            </div>
            <br />
          </div>
        </div>

        <br /><br />
      </div>

    </form>
  </mat-step>

  <mat-step [stepControl]="stepTwoForm">
    <form [formGroup]="stepTwoForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <p class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                  GOOGLE ASSISTANT PRIVACY SETTLEMENT CLAIM FORM
                </p>
                Please enter your (or if you are filing out the Claim Form for a minor, the Settlement Class Member’s) information in the chart below.<br /><br />

                If the Settlement Class Member is a minor, or person who is under the age of 18 as of March 19, 2026, a parent or legal guardian must fill out,
                sign, and submit this Claim Form on behalf of the minor.  To submit a claim on behalf of yourself and one or more minors, you must submit a
                separate Claim Form for each person.
              </div>
            </div>
          </div>
          <br />
          <div class="row lightgraybackground">
            <div class="col-md-12 text-center">
              Claimant Information
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <b><u>Age Verification</u></b><span style="color:red" class="required"> *</span><br /><br />
              <div class="form-group">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optSectionRadio" formControlName="optSectionRadio" id="1" [ngClass]="{ 'is-invalid': submitted && f.optSectionRadio.errors }" (change)="getRadioOptSectionRadioValue($event)" value="Under18">
                  <label class="form-check-label" for="1">
                    Are you <b>Under</b> 18?
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optSectionRadio" formControlName="optSectionRadio" id="2" [ngClass]="{ 'is-invalid': submitted && f.optSectionRadio.errors }" (change)="getRadioOptSectionRadioValue($event)" value="Over18">
                  <label class="form-check-label" for="2">
                    Are you <b>Over</b> 18?
                  </label>
                  <div *ngIf="submitted && f.optSectionRadio.errors" class="invalid-feedback">
                    <div *ngIf="f.optSectionRadio.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <p style="color:red;font-weight:bold">*This Field is Required</p>
            </div>
          </div>

          <div *ngIf="showDivOptSectionA == true">
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              NAME INFORMATION
            </div>
            <div class="row rowformat mt-4">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="classMemberName"><b>SETTLEMENT CLASS MEMBER NAME:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="classMemberName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.classMemberName.errors }" />
                  <div *ngIf="f.classMemberName.errors" class="invalid-feedback">
                    <div *ngIf="f.classMemberName.errors.required">This field is required</div>
                    <div *ngIf="f.classMemberName.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.classMemberName.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.classMemberName.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="guardianName"><b>PARENT/GUARDIAN NAME (FOR MINORS):</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="guardianName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.guardianName.errors }" />
                  <div *ngIf="f.guardianName.errors" class="invalid-feedback">
                    <div *ngIf="f.guardianName.errors.required">This field is required</div>
                    <div *ngIf="f.guardianName.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.guardianName.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.guardianName.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">

              ADDRESS INFORMATION
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="street1"><b>PARENT/GUARDIAN CURRENT STREET ADDRESS:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.street1.errors }" />
                  <div *ngIf="f.street1.errors" class="invalid-feedback">
                    <div *ngIf="f.street1.errors.required">This field is required</div>
                    <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.street1.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.street1.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="street2"><b>PARENT/GUARDIAN CURRENT STREET ADDRESS 2:</b></label>
                  <input type="text" class="form-control" formControlName="street2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.street2.errors }" />
                  <div *ngIf="f.street2.errors" class="invalid-feedback">
                    <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.street2.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.street2.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="city"><b>PARENT/GUARDIAN CITY:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.city.errors }" />
                  <div *ngIf="f.city.errors" class="invalid-feedback">
                    <div *ngIf="f.city.errors.required">This field is required</div>
                    <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.city.errors.maxlength">This field must not be greater than 40 characters</div>
                    <div *ngIf="f.city.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="state"><b>PARENT/GUARDIAN STATE:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': f.state.errors }">
                    <option value="">Please Select A State</option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                    <option value="District Of Columbia">District Of Columbia</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                    <option value="Guam">Guam</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Palau">Palau</option>
                    <option value="Virgin Islands">Virgin Islands</option>
                  </select>
                  <div *ngIf="f.state.errors" class="invalid-feedback">
                    <div *ngIf="f.state.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="zip"><b>PARENT/GUARDIAN ZIP CODE:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.zip.errors }" />
                  <div *ngIf="f.zip.errors" class="invalid-feedback">
                    <div *ngIf="f.zip.errors.required">This field is required</div>
                    <div *ngIf="f.zip.errors.pattern">
                      US zip Code with format 99999 or 99999-9999 alone are accepted
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">

              ADDRESS AT TIME YOUR CLAIMS WERE INCURRED
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="claimsIncurredStreet1"><b>STREET ADDRESS AT TIME YOUR CLAIMS WERE INCURRED:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredStreet1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredStreet1.errors }" />
                  <div *ngIf="f.claimsIncurredStreet1.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredStreet1.errors.required">This field is required</div>
                    <div *ngIf="f.claimsIncurredStreet1.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.claimsIncurredStreet1.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.claimsIncurredStreet1.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="claimsIncurredStreet2"><b>STREET ADDRESS 2 AT TIME YOUR CLAIMS WERE INCURRED:</b></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredStreet2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredStreet2.errors }" />
                  <div *ngIf="f.claimsIncurredStreet2.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredStreet2.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.claimsIncurredStreet2.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.claimsIncurredStreet2.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="claimsIncurredCity"><b>CITY AT TIME YOUR CLAIMS WERE INCURRED:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredCity.errors }" />
                  <div *ngIf="f.claimsIncurredCity.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredCity.errors.required">This field is required</div>
                    <div *ngIf="f.claimsIncurredCity.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.claimsIncurredCity.errors.maxlength">This field must not be greater than 40 characters</div>
                    <div *ngIf="f.claimsIncurredCity.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="claimsIncurredState"><b>STATE AT TIME YOUR CLAIMS WERE INCURRED:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="claimsIncurredState" [ngClass]="{ 'is-invalid': f.claimsIncurredState.errors }">
                    <option value="">Please Select A State</option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                    <option value="District Of Columbia">District Of Columbia</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                    <option value="Guam">Guam</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Palau">Palau</option>
                    <option value="Virgin Islands">Virgin Islands</option>
                  </select>
                  <div *ngIf="f.claimsIncurredState.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredState.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="claimsIncurredZip"><b>ZIP CODE AT TIME YOUR CLAIMS WERE INCURRED:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredZip.errors }" />
                  <div *ngIf="f.claimsIncurredZip.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredZip.errors.required">This field is required</div>
                    <div *ngIf="f.claimsIncurredZip.errors.pattern">
                      US zip Code with format 99999 or 99999-9999 alone are accepted
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">

              CONTACT INFORMATION
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhone"><b>PARENT/GUARDIAN’S PHONE NUMBER:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
                  <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                    <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhoneType"><b>PARENT/GUARDIAN’S PHONE NUMBER TYPE:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                    <option value="">Please select a phone type</option>
                    <option value="Cell">Mobile Phone</option>
                    <option value="Land">Land Line</option>
                  </select>
                  <div *ngIf="f.primaryPhoneType.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="emailAddress"><b>PARENT/GUARDIAN’S CONTACT EMAIL ADDRESS:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors }" />
                  <div *ngIf="f.emailAddress.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                    <div *ngIf="f.emailAddress.errors.mustMatch">Email Addresses must match</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="emailAddressVerify"><b>VERIFY PARENT/GUARDIAN’S CONTACT EMAIL ADDRESS:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="emailAddressVerify" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddressVerify.errors }" />
                  <div *ngIf="f.emailAddressVerify.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddressVerify.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddressVerify.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="f.emailAddressVerify.errors.pattern">This is not a valid email address</div>
                    <div *ngIf="f.emailAddressVerify.errors.mustMatch">Email Addresses must match</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="showDivOptSectionB == true">
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              NAME INFORMATION
            </div>
            <div class="row rowformat mt-4">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="classMemberName"><b>SETTLEMENT CLASS MEMBER NAME:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="classMemberName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.classMemberName.errors }" />
                  <div *ngIf="f.classMemberName.errors" class="invalid-feedback">
                    <div *ngIf="f.classMemberName.errors.required">This field is required</div>
                    <div *ngIf="f.classMemberName.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.classMemberName.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.classMemberName.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              ADDRESS INFORMATION
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="street1"><b>CURRENT STREET ADDRESS:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.street1.errors }" />
                  <div *ngIf="f.street1.errors" class="invalid-feedback">
                    <div *ngIf="f.street1.errors.required">This field is required</div>
                    <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.street1.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.street1.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="street2"><b>CURRENT STREET ADDRESS 2:</b></label>
                  <input type="text" class="form-control" formControlName="street2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.street2.errors }" />
                  <div *ngIf="f.street2.errors" class="invalid-feedback">
                    <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.street2.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.street2.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="city"><b>CITY:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.city.errors }" />
                  <div *ngIf="f.city.errors" class="invalid-feedback">
                    <div *ngIf="f.city.errors.required">This field is required</div>
                    <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.city.errors.maxlength">This field must not be greater than 40 characters</div>
                    <div *ngIf="f.city.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="state"><b>STATE:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': f.state.errors }">
                    <option value="">Please Select A State</option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                    <option value="District Of Columbia">District Of Columbia</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                    <option value="Guam">Guam</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Palau">Palau</option>
                    <option value="Virgin Islands">Virgin Islands</option>
                  </select>
                  <div *ngIf="f.state.errors" class="invalid-feedback">
                    <div *ngIf="f.state.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="zip"><b>ZIP CODE:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.zip.errors }" />
                  <div *ngIf="f.zip.errors" class="invalid-feedback">
                    <div *ngIf="f.zip.errors.required">This field is required</div>
                    <div *ngIf="f.zip.errors.pattern">
                      US zip Code with format 99999 or 99999-9999 alone are accepted
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">

              ADDRESS AT TIME YOUR CLAIMS WERE INCURRED
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="claimsIncurredStreet1"><b>STREET ADDRESS AT TIME YOUR CLAIMS WERE INCURRED:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredStreet1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredStreet1.errors }" />
                  <div *ngIf="f.claimsIncurredStreet1.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredStreet1.errors.required">This field is required</div>
                    <div *ngIf="f.claimsIncurredStreet1.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.claimsIncurredStreet1.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.claimsIncurredStreet1.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="claimsIncurredStreet2"><b>STREET ADDRESS 2 AT TIME YOUR CLAIMS WERE INCURRED:</b></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredStreet2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredStreet2.errors }" />
                  <div *ngIf="f.claimsIncurredStreet2.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredStreet2.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.claimsIncurredStreet2.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.claimsIncurredStreet2.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="claimsIncurredCity"><b>CITY AT TIME YOUR CLAIMS WERE INCURRED:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredCity.errors }" />
                  <div *ngIf="f.claimsIncurredCity.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredCity.errors.required">This field is required</div>
                    <div *ngIf="f.claimsIncurredCity.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.claimsIncurredCity.errors.maxlength">This field must not be greater than 40 characters</div>
                    <div *ngIf="f.claimsIncurredCity.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="claimsIncurredState"><b>STATE AT TIME YOUR CLAIMS WERE INCURRED:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="claimsIncurredState" [ngClass]="{ 'is-invalid': f.claimsIncurredState.errors }">
                    <option value="">Please Select A State</option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                    <option value="District Of Columbia">District Of Columbia</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                    <option value="Guam">Guam</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Palau">Palau</option>
                    <option value="Virgin Islands">Virgin Islands</option>
                  </select>
                  <div *ngIf="f.claimsIncurredState.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredState.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="claimsIncurredZip"><b>ZIP CODE AT TIME YOUR CLAIMS WERE INCURRED:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="claimsIncurredZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.claimsIncurredZip.errors }" />
                  <div *ngIf="f.claimsIncurredZip.errors" class="invalid-feedback">
                    <div *ngIf="f.claimsIncurredZip.errors.required">This field is required</div>
                    <div *ngIf="f.claimsIncurredZip.errors.pattern">
                      US zip Code with format 99999 or 99999-9999 alone are accepted
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              CONTACT INFORMATION
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhone"><b>PHONE NUMBER:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
                  <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                    <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhoneType"><b>PHONE NUMBER TYPE:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                    <option value="">Please select a phone type</option>
                    <option value="Cell">Mobile Phone</option>
                    <option value="Land">Land Line</option>
                  </select>
                  <div *ngIf="f.primaryPhoneType.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="emailAddress"><b>CONTACT EMAIL ADDRESS:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors }" />
                  <div *ngIf="f.emailAddress.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                    <div *ngIf="f.emailAddress.errors.mustMatch">Email Addresses must match</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="emailAddressVerify"><b>VERIFY CONTACT EMAIL ADDRESS:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="emailAddressVerify" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddressVerify.errors }" />
                  <div *ngIf="f.emailAddressVerify.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddressVerify.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddressVerify.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="f.emailAddressVerify.errors.pattern">This is not a valid email address</div>
                    <div *ngIf="f.emailAddressVerify.errors.mustMatch">Email Addresses must match</div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>

          <br />
          <ul class="list-inline float-right">
            <li>
              <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button class="btn btn-primary" (click)="saveAndValidateStepTwo()">Next</button>
            </li>
          </ul>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepThreeForm">
    <form [formGroup]="stepThreeForm">
      <div class="card border-0">

        <div class="card-body">
          <h4 style="text-align:center">
            <b>
              GOOGLE ASSISTANT PRIVACY SETTLEMENT CLAIM FORM

            </b>
          </h4>
          <br />
          <div class="row lightgraybackground">
            <div class="col-md-12 text-center">
              <br />
            </div>
          </div>
          <br />
          <div class="row rowformat">
            <div class="col-md-12">
              <h5><b><u>Purchaser Class Settlement</u></b><br /></h5><br />

              If you are a member of the Purchaser Settlement Class, provide the email address(es) for your Google account(s) associated with your purchased Google-Made Device(s).<br /><br />

              You are a member of the Purchaser Settlement Class if you are a User who purchased a Google-Made
              Device in the United States or its territories between May 18, 2016 and March 19, 2026.<br /><br />
            </div>
          </div>
          <br />
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="settlementClassPurchaser"><b>ARE YOU A MEMBER OF THE PURCHASER CLASS?:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="settlementClassPurchaser" (change)="getPurchaserClassValue($event)" [ngClass]="{ 'is-invalid': g.settlementClassPurchaser.errors }">
                  <option value="">Please select an option</option>
                  <option value="Yes">Yes, I am a member of the Purchaser Class</option>
                  <option value="No">No, I am not a member of the Purchaser Class</option>
                </select>
                <div *ngIf="g.settlementClassPurchaser.errors" class="invalid-feedback">
                  <div *ngIf="g.settlementClassPurchaser.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showDivPurchaserClass == true">
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="googleMadeDeviceEmailAddress"><b>EMAIL ADDRESS ASSOCIATED WITH APPLICABLE GOOGLE-MADE DEVICE:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" formControlName="googleMadeDeviceEmailAddress" (change)="getPurchaserClassValue($event)" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': g.googleMadeDeviceEmailAddress.errors }" />
                  <div *ngIf="g.googleMadeDeviceEmailAddress.errors" class="invalid-feedback">
                    <div *ngIf="g.googleMadeDeviceEmailAddress.errors.required">This field is requireds</div>
                    <div *ngIf="g.googleMadeDeviceEmailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="g.googleMadeDeviceEmailAddress.errors.pattern">This is not a valid email address</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-body bg-light mt-3">
              <div class="card-header bg-primary text-white">
                Purchaser Settlement Class
              </div>
              <br />
              <div class="row mb-3">
                <div class="col-md-12">
                  <b>
                    You may make a claim for each Google-Made Device you purchased in the United States or its territories during
                    the Class Period up to a maximum of three (3) Google-Made Devices. You must provide the total number of
                    devices claimed and the device model name, serial number or IMEI number (for a mobile device), and proof of
                    purchase (list the type of proof you will upload on the next page) for each claimed Google-Made Device below:
                  </b>
                  <br /><br />
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="modelName">
                          Google-Made Device Model Name:
                          <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                        </label>
                        <input type="text" class="form-control" (change)="getPurchaserClassValue($event)" formControlName="modelName" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.modelName.errors }" />
                        <div *ngIf="clicked && g.modelName.errors" class="invalid-feedback">
                          <div *ngIf="g.modelName.errors.required">This field is required</div>
                          <div *ngIf="g.modelName.errors.minlength">This field cannot be less than 2 characters</div>
                          <div *ngIf="g.modelName.errors.maxlength">This field cannot be greater than 150 characters</div>
                          <div *ngIf="g.modelName.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                        </div>

                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="serialOrImeiNumberPurchaser">
                          Serial Number or IMEI Number:
                          <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                        </label>
                        <input type="text" class="form-control" (change)="getPurchaserClassValue($event)" formControlName="serialOrImeiNumberPurchaser" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.serialOrImeiNumberPurchaser.errors }" />
                        <div *ngIf="clicked && g.serialOrImeiNumberPurchaser.errors" class="invalid-feedback">
                          <div *ngIf="g.serialOrImeiNumberPurchaser.errors.required">This field is required</div>
                          <div *ngIf="g.serialOrImeiNumberPurchaser.errors.minlength">This field cannot be less than 10 characters</div>
                          <div *ngIf="g.serialOrImeiNumberPurchaser.errors.maxlength">This field cannot be greater than 25 characters</div>
                          <div *ngIf="g.serialOrImeiNumberPurchaser.errors.pattern">Only use numbers and letters.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">

                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="proofOfPurchase">
                          Proof of Purchase
                          <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                        </label>
                        <input type="text" class="form-control" (change)="getPurchaserClassValue($event)" formControlName="proofOfPurchase" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.proofOfPurchase.errors }" />
                        <div *ngIf="clicked && g.proofOfPurchase.errors" class="invalid-feedback">
                          <div *ngIf="g.proofOfPurchase.errors.required">This field is required</div>
                          <div *ngIf="g.proofOfPurchase.errors.minlength">This field cannot be less than 2 characters</div>
                          <div *ngIf="g.proofOfPurchase.errors.maxlength">This field cannot be greater than 150 characters</div>
                          <div *ngIf="g.proofOfPurchase.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" (click)="addPurchasesData()" class="btn btn-success">Add Purchaser Information</button>&nbsp;
                      <button type="button" (click)="clearPurchasesData()" class="btn btn-danger btn-sm">Clear Purchaser Information</button>
                    </div>
                  </div>
                  <br /><br />
                  <b>Proof of Purchase (<i>for example: Google Store receipt, Best Buy receipt</i>)</b>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table" #listofFiles>
                    <thead>
                      <tr>
                        <th class="tableHeaderFormattedText">Model Name</th>
                        <th class="tableHeaderFormattedText">Serial or IMEI Number</th>
                        <th class="tableHeaderFormattedText">Proof of Purchase</th>
                        <th class="tableHeaderFormattedText">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let pl of purchaseList; let i = index">
                        <td class="hidden">{{i}}</td>
                        <td class="tableRowFormattedText">{{pl.ModelName}}</td>
                        <td class="tableRowFormattedText">{{pl.SerialOrImeiNumberPurchaser}}</td>
                        <td class="tableRowFormattedText">{{pl.ProofOfPurchase}}</td>
                        <td>
                          <button type="button" class="btn btn-danger"
                                  (click)="removePurchasesRow(i)">
                            Remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div style="font-size: 1.0em;">
              <div class="text-center" *ngIf="showDivForPurchaseMaximumhit" style="color:red; font-weight:bold; font-size:1.3em">
                A maximum of 3 entries is allowed.
              </div>
              <br />
              <div class="text-center" *ngIf="showMessage" style="color:red; font-weight:bold; font-size:1.3em">
                Please ensure you click the add button to save your information.
              </div>
              <br />
              <div class="text-center" *ngIf="showDivForPurchaserMinimumhit" style="color:red; font-weight:bold; font-size:1.3em">
                A minimum of 1 entry is required in the Purchasers Table.
              </div>
            </div>
          </div>



         

          <br />
          <ul class="list-inline float-right">
            <li>
              <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button class="btn btn-primary" (click)="saveAndValidateStepThree()">Next</button>
            </li>
          </ul>

        </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepFourForm">
    <form [formGroup]="stepFourForm">
      <div class="card border-0">

        <div class="card-body">
          <h4 style="text-align:center">
            <b>
              GOOGLE ASSISTANT PRIVACY SETTLEMENT CLAIM FORM

            </b>
          </h4>
          <br />
          <div class="row lightgraybackground">
            <div class="col-md-12 text-center">
              <br />
            </div>
          </div>
          <br />
          <div class="row rowformat">
            <div class="col-md-12">
              <h5><b><u>Privacy Class Settlement</u></b></h5><br /><br />

              If you are a member of the Privacy Settlement Class and you are a household member (<i>i.e</i>., not a User), provide the name and email address associated with the Google account of the User who maintains or maintained the Google Assistant Enabled Device in your household.<br /><br />

              You are a member of the Privacy Settlement Class if between May 18, 2016 and March 19, 2026, you
              were a User of a Google Assistant Enabled Device or were a member of a User’s Household, and your
              communications were recorded or otherwise obtained by Google Assistant as a result of a False Accept
              or disclosed to any third-party review vendor.<br /><br />

              Each User or Household Member must file their own separate claim.
            </div>
          </div>
          <br />
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="settlementClassPrivacy"><b>ARE YOU A MEMBER OF THE PRIVACY SETTLEMENT CLASS?:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="settlementClassPrivacy" (change)="getPrivateClassValue($event)" [ngClass]="{ 'is-invalid': h.settlementClassPrivacy.errors }">
                  <option value="">Please select an option</option>
                  <option value="Yes">Yes, I am a member of the Privacy Settlement Class</option>
                  <option value="No">No, I am not a member of the Privacy Settlement Class</option>
                </select>
                <div *ngIf="h.settlementClassPrivacy.errors" class="invalid-feedback">
                  <div *ngIf="h.settlementClassPrivacy.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showDivPrivacyClass == true">
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="primaryPhone"><b>PLEASE SELECT IF YOU ARE THE USER OR A MEMBER OF THE USER’S HOUSEHOLD:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <select class="form-control" formControlName="userOrMember" [ngClass]="{ 'is-invalid': h.userOrMember.errors }">
                    <option value="">Please select user or household member</option>
                    <option value="User">User</option>
                    <option value="Household Member">Household Member</option>
                  </select>
                  <div *ngIf="h.userOrMember.errors" class="invalid-feedback">
                    <div *ngIf="h.userOrMember.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="associatedGoogleAccountName"><b>NAME OF HOUSEHOLD MEMBER ASSOCIATED WITH THE APPLICABLE GOOGLE ACCOUNT:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" (change)="getPrivateClassValue($event)" formControlName="associatedGoogleAccountName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': h.associatedGoogleAccountName.errors }" />
                  <div *ngIf="h.associatedGoogleAccountName.errors" class="invalid-feedback">
                    <div *ngIf="h.associatedGoogleAccountName.errors.minlength">This field must not be less than 2 characters</div>
                    <div *ngIf="h.associatedGoogleAccountName.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="h.associatedGoogleAccountName.errors.required">This field is required</div>
                    <div *ngIf="h.associatedGoogleAccountName.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="associatedGoogleAccountEmailAddress"><b>EMAIL ADDRESS ASSOCIATED WITH THE APPLICABLE GOOGLE ACCOUNT:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                  <input type="text" class="form-control" (change)="getPrivateClassValue($event)" formControlName="associatedGoogleAccountEmailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': h.associatedGoogleAccountEmailAddress.errors }" />
                  <div *ngIf="h.associatedGoogleAccountEmailAddress.errors" class="invalid-feedback">
                    <div *ngIf="h.associatedGoogleAccountEmailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="h.associatedGoogleAccountEmailAddress.errors.required">This field is required</div>
                    <div *ngIf="h.associatedGoogleAccountEmailAddress.errors.pattern">This is not a valid email address</div>
                  </div>
                </div>
              </div>
            </div>
            <br /><br />
            <div class="card card-body bg-light mt-3">
              <div class="card-header bg-primary text-white">
                Privacy Settlement Class
              </div>
              <br />
              <div class="row mb-3">
                <div class="col-md-12">
                  <b>
                    You must provide the device type (<i>for example: smart speaker, smart display, smartphone, etc.</i>), model name, and serial number or IMEI
                    number (for a mobile device) for the applicable Google Assistant Enabled Device in your Household below:
                  </b>
                  <br /><br />
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="googleDeviceType">
                          Google Assistant Enabled
                          Device Type:
                          <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                        </label>
                        <input type="text" class="form-control" (change)="getPrivateClassValue($event)" formControlName="googleDeviceType" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && h.googleDeviceType.errors }" />
                        <div *ngIf="clicked && h.googleDeviceType.errors" class="invalid-feedback">
                          <div *ngIf="h.googleDeviceType.errors.required">This field is required</div>
                          <div *ngIf="h.googleDeviceType.errors.minlength">This field cannot be less than 2 characters</div>
                          <div *ngIf="h.googleDeviceType.errors.maxlength">This field cannot be greater than 150 characters</div>
                          <div *ngIf="h.googleDeviceType.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="googleDeviceModelName">
                          Google Assistant Enabled
                          Device Model Name:                          <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                        </label>
                        <input type="text" class="form-control" (change)="getPrivateClassValue($event)" formControlName="googleDeviceModelName" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && h.googleDeviceModelName.errors }" />
                        <div *ngIf="clicked && h.googleDeviceModelName.errors" class="invalid-feedback">
                          <div *ngIf="h.googleDeviceModelName.errors.required">This field is required</div>
                          <div *ngIf="h.googleDeviceModelName.errors.minlength">This field cannot be less than 2 characters</div>
                          <div *ngIf="h.googleDeviceModelName.errors.maxlength">This field cannot be greater than 150 characters</div>
                          <div *ngIf="h.googleDeviceModelName.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#).</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="serialOrImeiNumberPrivacy">
                          Serial Number or IMEI Number:
                          <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                        </label>
                        <input type="text" class="form-control" (change)="getPrivateClassValue($event)" formControlName="serialOrImeiNumberPrivacy" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && h.serialOrImeiNumberPrivacy.errors }" />
                        <div *ngIf="clicked && h.serialOrImeiNumberPrivacy.errors" class="invalid-feedback">
                          <div *ngIf="h.serialOrImeiNumberPrivacy.errors.required">This field is required</div>
                          <div *ngIf="h.serialOrImeiNumberPrivacy.errors.minlength">This field cannot be less than 10 characters</div>
                          <div *ngIf="h.serialOrImeiNumberPrivacy.errors.maxlength">This field cannot be greater than 25 characters</div>
                          <div *ngIf="h.serialOrImeiNumberPrivacy.errors.pattern">Only use letters and numbers</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" (click)="addSalesData()" class="btn btn-success">Add Privacy Information</button>&nbsp;
                      <button type="button" (click)="clearSalesData()" class="btn btn-danger btn-sm">Clear Privacy Information</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table" #listofFiles>
                    <thead>
                      <tr>
                        <th class="tableHeaderFormattedText">Google Device Type</th>
                        <th class="tableHeaderFormattedText">Google Device Model Name</th>
                        <th class="tableHeaderFormattedText">Serial or IMEI Number</th>
                        <th class="tableHeaderFormattedText">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let sl of saleList; let i = index">
                        <td class="hidden">{{i}}</td>
                        <td class="tableRowFormattedText">{{sl.GoogleDeviceType}}</td>
                        <td class="tableRowFormattedText">{{sl.GoogleDeviceModelName}}</td>
                        <td class="tableRowFormattedText">{{sl.SerialOrImeiNumberPrivacy}}</td>
                        <td>
                          <button type="button" class="btn btn-danger"
                                  (click)="removeSalesRow(i)">
                            Remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>


            </div>
            <div style="font-size: 1.0em;">
              <div class="text-center" *ngIf="showDivForPrivacyMaximumhit" style="color:red; font-weight:bold; font-size:1.3em">
                A maximum of 1 entry is allowed.
              </div>
              <br />
              <div class="text-center" *ngIf="showMessage" style="color:red; font-weight:bold; font-size:1.3em">
                Please ensure you click the add button to save your information.
              </div>
              <br />
              <div class="text-center" *ngIf="showDivForPrivacyMinimumhit" style="color:red; font-weight:bold; font-size:1.3em">
                A minimum of 1 entry is required in the Privacy Table.
              </div>
            </div>
          </div>

   

          <br />
          <ul class="list-inline float-right">
            <li>
              <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button class="btn btn-primary" (click)="saveAndValidateStepFour()">Next</button>
            </li>
          </ul>

        </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepFiveForm">
    <form [formGroup]="stepFiveForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <div class="card-body">
          <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
            Upload Documents
          </div>
          <br />
          <div style="font-size: 1.0em;">
            <div class="row">
              <div class="col-md-12">
                Please submit legible copies of supporting documentation. Do not send originals, but maintain the originals in your records.
                Claimants may be requested to furnish additional information regarding this Claim Form that the Claims Administrator, Class
                Counsel, or the Court may require.
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
                <label for="file" class="btn btn-primary btn-sm">Documents To Upload</label>
                <br />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-sm-12">
                <table class="table" #listofFiles>
                  <thead>
                    <tr>
                      <th class="hidden">Id</th>
                      <th>Files To Be Uploaded</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sd of supportingDocuments; let i = index">
                      <td class="hidden">{{i}}</td>
                      <td>{{sd.name}}</td>
                      <td>
                        <button type="button" class="btn btn-danger" (click)="removeRow(i)">Remove</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br />
            <ul class="list-inline float-right">
              <li>
                <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                <button class="btn btn-primary" (click)="saveAndValidateStepFive()">Next</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepSixForm">
    <form [formGroup]="stepSixForm">
      <div class="card border-0">

        <div class="card-body">
          <br />
          <div class="row lightgraybackground">
            <div class="col-md-12 text-center">
              FORM OF PAYMENT
            </div>
          </div>
          <br />
          <div style="font-weight:bold;">
            <u>Please select your form of payment</u>.<span style="color:red; font-weight:bold" class="required"> *One Selection is Required</span>
          </div>
          <br /><br />
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="ACH">
                  <label class="form-check-label" for="1">
                    <b>ACH</b><br /><br />

                    By selecting ACH, I verify that the name on the account is the same name as on the claim. Please select
                    checking or savings, and provide your routing number and account number in the boxes provided below.<br /><br />
                  </label>
                </div>
                <div *ngIf="showDivACH == true">
                  <div class="row rowformat">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="achAccountType"><b>Account Type:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                        <select class="form-control" formControlName="achAccountType" [ngClass]="{ 'is-invalid': j.achAccountType.errors }">
                          <option value="">Please select an account type</option>
                          <option value="Checking">Checking</option>
                          <option value="Savings">Savings</option>
                        </select>
                        <div *ngIf="j.achAccountType.errors" class="invalid-feedback">
                          <div *ngIf="j.achAccountType.errors.required">This field is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row rowformat">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="achRoutingNumber"><b>9-Digit Routing Number:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                        <input type="text" class="form-control" formControlName="achRoutingNumber" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': j.achRoutingNumber.errors }" />
                        <div *ngIf="j.achRoutingNumber.errors" class="invalid-feedback">
                          <div *ngIf="j.achRoutingNumber.errors.required">This field is required</div>
                          <div *ngIf="j.achRoutingNumber.errors.maxlength">This field must not be greater than 9 digits</div>
                          <div *ngIf="j.achRoutingNumber.errors.minlength">This field must be at least 9 digits</div>
                          <div *ngIf="j.achRoutingNumber.errors.pattern">Only use Digits 0-9</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="achAccountNumber"><b>Account Number:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                        <input type="text" class="form-control" formControlName="achAccountNumber" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': j.achAccountNumber.errors }" />
                        <div *ngIf="j.achAccountNumber.errors" class="invalid-feedback">
                          <div *ngIf="j.achAccountNumber.errors.required">This field is required</div>
                          <div *ngIf="j.achAccountNumber.errors.maxlength">This field must not be greater than 17 digits</div>
                          <div *ngIf="j.achAccountNumber.errors.minlength">This field must be at least 8 digits</div>
                          <div *ngIf="j.achAccountNumber.errors.pattern">Only use Digits 0-9</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="Zelle">
                  <label class="form-check-label" for="2">
                    <b>Zelle</b><br /><br />

                    By selecting Zelle, I agree that the information necessary to receive payment from this vendor is the same as
                    the information provided in the claim.<br /><br />
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="PayPal">
                  <label class="form-check-label" for="3">
                    <b>PayPal</b><br /><br />

                    By selecting PayPal, I agree that the information necessary to receive payment from this vendor is the same
                    as the information provided in the claim.<br /><br />
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="Venmo">
                  <label class="form-check-label" for="4">
                    <b>Venmo</b><br /><br />

                    By selecting Venmo, I agree that the information necessary to receive payment from this vendor is the same
                    as the information provided in the claim.<br /><br />
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="Paper Check">
                  <label class="form-check-label" for="5">
                    <b>Paper Check</b><br /><br />

                    By selecting Paper Check, I understand that a check will be mailed to the name and address provided in this
                    claim.<br /><br />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" *ngIf="showDivForPaymentOptionRequired" style="color:red; font-weight:bold; font-size:1.3em">
            Please select a form of payment.
          </div>
          <div>
            <b>
              As part of the claims review and audit process, you may be asked to provide additional proof to substantiate
              your claim. You do not need to provide additional proof with your Claim Form at this time. However, the
              Claims Administrator may ask you to provide additional documents to prove your claim during the review
              process. If you are asked to provide additional proof and you do not, your claim may be rejected.
            </b>
          </div>

          <br />
          <ul class="list-inline float-right">
            <li>
              <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button class="btn btn-primary" (click)="saveAndValidateStepSix()">Next</button>
            </li>
          </ul>

        </div>
      </div>
    </form>
  </mat-step>



  <mat-step [stepControl]="stepSevenForm">
    <form [formGroup]="stepSevenForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <div class="card-body">
          <div class="container" style="border:1px solid #bebaba">
            <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
              ATTESTATION AND CERTIFICATION
            </div>
            <br />

            <div class="row">
              <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
                Regardless of whether you are filing this claim as a member of the Purchaser Class or the Privacy Settlement Class, please confirm the following by inserting a check mark in the boxes provided:.<br /><br />

                <!--Question 1-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkbox1" class="form-check-input" [ngClass]="{ 'is-invalid': k.checkbox1.errors }" ngModel required />
                    <label for="checkbox1">
                      <b>
                        I attest that I (or my minor child) reside in the United States or its territories.
                      </b>            <span style="font-weight:bold;color:red" class="required"> *</span>
                    </label>
                    <div *ngIf="k.checkbox1.errors" class="invalid-feedback">
                      <div *ngIf="k.checkbox1.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>

                <!--Question 2-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkbox2" class="form-check-input" [ngClass]="{ 'is-invalid': k.checkbox2.errors }" ngModel required />
                    <label for="checkbox2">
                      <b>
                        I (or the minor for whom I am submitting this claim) am/is a Settlement Class Member. I/They did not submit a request to exclude myself/themselves, or “opt out of,” the Settlement.
                      </b>            <span style="font-weight:bold;color:red" class="required"> *</span>
                    </label>
                    <div *ngIf="k.checkbox2.errors" class="invalid-feedback">
                      <div *ngIf="k.checkbox2.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>

                <!--Question 3-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkbox3" class="form-check-input" [ngClass]="{ 'is-invalid': k.checkbox3.errors }" ngModel required />
                    <label for="checkbox3">
                      <b>
                        I attest that I (or my minor child) reside in the United States or its territories.
                      </b>            <span style="font-weight:bold;color:red" class="required"> *</span>
                    </label>
                    <div *ngIf="k.checkbox3.errors" class="invalid-feedback">
                      <div *ngIf="k.checkbox3.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>

                <!--Question 4-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkbox4" class="form-check-input" [ngClass]="{ 'is-invalid': k.checkbox4.errors }" ngModel required />
                    <label for="checkbox4">
                      <b>
                        I (or the minor for whom I am submitting this claim) confirm my/their intent to participate in the Settlement as a member of one or both Settlement Class(es), including if applicable by revoking any prior request to exclude myself/themselves from the certified Purchaser Class.
                      </b><span style="font-weight:bold;color:red" class="required"> *</span>
                    </label>
                    <div *ngIf="k.checkbox4.errors" class="invalid-feedback">
                      <div *ngIf="k.checkbox4.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>

                <!--Question 5-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkbox5" class="form-check-input" [ngClass]="{ 'is-invalid': k.checkbox5.errors }" ngModel required />
                    <label for="checkbox5">
                      <b>
                        I understand, agree, and consent that the Claims Administrator and Settlement Class Counsel may contact me electronically via email and/or mobile phone (message & data rates may apply).
                      </b>            <span style="font-weight:bold;color:red" class="required"> *</span>
                    </label>
                    <div *ngIf="k.checkbox5.errors" class="invalid-feedback">
                      <div *ngIf="k.checkbox5.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>

                <!--Question 6-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkbox6" class="form-check-input" [ngClass]="{ 'is-invalid': k.checkbox6.errors }" ngModel required />
                    <label for="checkbox6">
                      <b>
                        I agree to use my best efforts to provide more information related to my claim if the Claims Administrator asks me to do so.
                      </b>            <span style="font-weight:bold;color:red" class="required"> *</span>
                    </label>
                    <div *ngIf="k.checkbox6.errors" class="invalid-feedback">
                      <div *ngIf="k.checkbox6.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>
                <br />
                <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
                  Purchaser Settlement Class
                </div>
                <br />
                If you are filing this claim as a member of the Purchaser Settlement Class, you are required to attest under
                penalty of perjury to each of the following statements as true.<br /><br />
                Please confirm by inserting a check mark in the box provided:<br /><br />

                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkBoxMemberOfPurchaserClass" class="form-check-input" />
                    <label for="checkBoxMemberOfPurchaserClass">
                      <b>
                        I am a member of the Purchaser Settlement Class
                      </b>
                    </label>
                    <div *ngIf="k.checkBoxMemberOfPurchaserClass.errors" class="invalid-feedback">
                    </div>
                  </div>
                </div>


                <!--Question 8-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkboxPurchaserGoogleAccountConfirmation" class="form-check-input" />
                    <label for="checkboxPurchaserGoogleAccountConfirmation">
                      <b>
                        I attest that I (or my minor child) have or had a Google account that was associated with at least one
                        Google-Made Device purchased by me (or my minor child).
                      </b><span style="font-weight:bold;color:red" class="required">This field is required if you are a member of the Purchaser Settlement Class</span>
                    </label>
                    <div *ngIf="k.checkboxPurchaserGoogleAccountConfirmation.errors" class="invalid-feedback">
                    </div>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-6">
                    <button type="button" (click)="clearPurchaseCheckboxes()" class="btn btn-danger btn-sm">Clear Purchaser Checkboxes</button>
                  </div>
                </div>

                <br />
                <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
                  Privacy Settlement Class
                </div>
                <br />
                If you are filing this claim as a member of the Privacy Settlement Class, you are required to attest under penalty
                of perjury that you have a good faith belief that each of the following statements is true.<br /><br />
                Please confirm by inserting a check mark in the boxes provided:<br /><br />
                <!--Question 9-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkBoxMemberOfPrivacyClass" class="form-check-input" />
                    <label for="checkBoxMemberOfPrivacyClass">
                      <b>
                        I am a member of the Privacy Settlement Class
                      </b>
                    </label>
                    <div *ngIf="k.checkBoxMemberOfPrivacyClass.errors" class="invalid-feedback">
                    </div>
                  </div>
                </div>

                <!--Question 9-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="attestMemberOfPrivacyClass" class="form-check-input" />
                    <label for="attestMemberOfPrivacyClass">
                      <b>
                        I attest that, between May 18, 2016 and March 19, 2026, I (or my minor child) (select one of the
                        following):
                      </b>                  <span style="font-weight:bold;color:red" class="required">This field is required if you are a member of the Privacy Settlement Class</span>

                    </label>
                    <div *ngIf="k.attestMemberOfPrivacyClass.errors" class="invalid-feedback">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                  </div>
                  <!--Question 10-->
                  <div class="col-md-8">
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="attestMemberOfPrivacyClassSelection" formControlName="attestMemberOfPrivacyClassSelection" id="1" [ngClass]="{ 'is-invalid': k.attestMemberOfPrivacyClassSelection.errors }" value="User">
                        <label class="form-check-label" for="1">

                          have or had a Google account that was associated with at least one Google Assistant Enabled Device
                          in my Household;

                        </label>
                      </div>
                      <br />
                      <b>OR</b>
                      <br />
                      <br />
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="attestMemberOfPrivacyClassSelection" formControlName="attestMemberOfPrivacyClassSelection" id="2" [ngClass]="{ 'is-invalid': k.attestMemberOfPrivacyClassSelection.errors }" value="Household">
                        <label class="form-check-label" for="2">
                          was a Household member of a person that has or had a Google account that was associated with at least
                          one Google Assistant Enabled Device in my Household.

                        </label>
                        <div *ngIf="submitted && k.attestMemberOfPrivacyClassSelection.errors" class="invalid-feedback">

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Question 11-->
                <div class="col-md-12">
                  <div class="form-group form-check">
                    <input type="checkbox" formControlName="checkBoxPrivacyCommunicationsRecorded" class="form-check-input" />
                    <label for="checkBoxPrivacyCommunicationsRecorded">
                      <b>
                        I have a good faith belief that, between May 18, 2016 and March 19, 2026, my (or my minor child’s)
                        communications were recorded or otherwise obtained by Google Assistant through the Google Assistant Enabled
                        Device in my Household as a result of a False Accept or disclosed to any third-party review vendor.
                      </b><span style="font-weight:bold;color:red" class="required">This field is required if you are a member of the Privacy Settlement Class</span>

                    </label>
                    <div *ngIf="k.checkBoxPrivacyCommunicationsRecorded.errors" class="invalid-feedback">
                    </div>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-6">
                    <button type="button" (click)="clearPrivacyCheckboxes()" class="btn btn-danger btn-sm">Clear Privacy Checkboxes</button>
                  </div>
                </div>
                <br />

              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              Signature
            </div>
            <br />
            <div style="font-size: 1.0em;">
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="signature"><b>Signature of Claimant:</b><span style="color:red" class="required"> *</span></label>
                    <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': k.signature.errors }" />
                    <div *ngIf="k.signature.errors" class="invalid-feedback">
                      <div *ngIf="k.signature.errors.required">This field is required</div>
                      <div *ngIf="k.signature.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="k.signature.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="k.signature.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-4">
                  <div class="form-group">
                    <!--<label for="noticeId"><b>noticeId of Claimant:</b><span style="color:red" class="required"> *</span></label>-->
                    <input type="text" class="form-control" id="noticeId" readonly hidden formControlName="noticeId" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': k.noticeId.errors }" />
                    <div *ngIf="k.noticeId.errors" class="invalid-feedback">
                      <div *ngIf="k.noticeId.errors.required">This field is required</div>
                      <div *ngIf="k.noticeId.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="k.noticeId.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="k.noticeId.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <!--<label for="uniqueId"><b>uniqueId of Claimant:</b><span style="color:red" class="required"> *</span></label>-->
                    <input type="text" class="form-control" id="uniqueId" readonly hidden formControlName="uniqueId" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': k.uniqueId.errors }" />
                    <div *ngIf="k.uniqueId.errors" class="invalid-feedback">
                      <div *ngIf="k.uniqueId.errors.required">This field is required</div>
                      <div *ngIf="k.uniqueId.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="k.uniqueId.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="k.uniqueId.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <!--<label for="pin"><b>pin of Claimant:</b><span style="color:red" class="required"> *</span></label>-->
                    <input type="text" class="form-control" id="pin" readonly hidden formControlName="pin" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': k.pin.errors }" />
                    <div *ngIf="k.pin.errors" class="invalid-feedback">
                      <div *ngIf="k.pin.errors.required">This field is required</div>
                      <div *ngIf="k.pin.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="k.pin.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="k.pin.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid':  k.googleRecaptchaToken.errors }"></re-captcha>
                    <div *ngIf="k.googleRecaptchaToken.errors" class="invalid-feedback">
                      <div *ngIf="k.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                    </div>
                    <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

                  </div>
                </div>
              </div>
              <br />              <div class="row">
                <div class="col-md-12">
                  <h4 class="text-center" style="font-weight:bold; text-align:center">
                    ACCURATE CLAIMS PROCESSING TAKES A<br /> SIGNIFICANT AMOUNT OF TIME.<br /> THANK YOU FOR YOUR PATIENCE.
                  </h4>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h5 class="text-center" style="text-decoration:underline">
                    REMINDER CHECKLIST:
                  </h5>
                </div>

                <div class="col-md-12" style="text-align:justify; text-justify:auto; margin-top:2%">
                  1.	Sign this claim form by typing your name into the box above.<br /><br />
                  2.	DO NOT HIGHLIGHT YOUR SUPPORTING DOCUMENTATION.<br /><br />
                  3.	Keep a copy of the reference number provided on the next page. Please use this number for all communications regarding this claim.<br /><br />
                  4.	If you move after submitting this Claim Form, please notify the Claims Administrator of the change in your address, otherwise you may not receive additional notices or payment.
                </div>

              </div>
              <br /><br />
              <div class="row">
                <div class="col-md-12 text-center">
                  <div *ngIf="showDivSubmittalErrorMessage == true" class="submittal-custom-error" style="color:red">
                    Submission failed, if you are apart of the Purchaser and or Privacy Settlement class, please ensure all checkboxes have been marked in that section. Please also double check the first 6 checkboxes have been checked. If these are checked, please try again.
                  </div>
                </div>
              </div>
              <br />
              <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
                <div class="col-md-12 text-center" style="font-weight:bold">
                  Claim Submission Failed, please fill out a paper claim form and email it to <a href="mailto:info@googleassistantprivacylitigation.com">info@googleassistantprivacylitigation.com</a>.<br />
                  Thank You.
                </div>
              </div>
              <br/>
              <ul class="list-inline float-right">
                <li>
                  <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                  <button class="btn btn-primary" [disabled]="submitClicked" (click)="onSubmit()" type="submit">Submit</button>
                </li>
              </ul>
              <br /><br />
            </div>
          </div>
        </div>
      </div>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Saving Data...</p>
    </ngx-spinner>
  </mat-step>

</mat-horizontal-stepper>

